module.exports = __webpack_public_path__ + "img/panorama-before-LM.4b3c6537.jpg";